"use client"
import { useContext, useEffect } from "react"
import { AuthContext } from "../../contexts/AuthContext"
import { UserProvider, useUser } from "../../contexts/UserContext"

import {
    ChevronsUpDown,
    LogOut,
    UserRoundCog
} from "lucide-react"

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu"

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "../../components/ui/sidebar"
import { useNavigate } from "react-router-dom"

export function NavFooter() {
    const { isMobile, setOpen} = useSidebar();
    const {user, setUser} = useUser();    
    const {logout} = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogOut = () => 
    {
        logout();
        setUser(null);
        navigate("/signin")
    }

     const handleNavigate = (path: string) => {
      setOpen(false); // close sidebar
      navigate(path);
    }
    
    return (
      <UserProvider>
      <SidebarMenu>
        <SidebarMenuItem>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <SidebarMenuButton
                size="lg"
                className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
              >
                <Avatar className="h-8 w-8 rounded-lg">
                  <AvatarImage src={user?.avatarUrl} alt={user?.fullName} />
                  <AvatarFallback className="rounded-lg">{user?.initials || `G`}</AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">{user?.fullName || `Guest`}</span>
                </div>
                <ChevronsUpDown className="ml-auto size-4" />
              </SidebarMenuButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
              // side={isMobile ? "bottom" : "right"}
              side={isMobile ? "top" : "right"}
              align="end"
              sideOffset={4}
            >
              <DropdownMenuItem onClick={()=> handleNavigate("/profile")} >
                <UserRoundCog />
                Profile
              </DropdownMenuItem>
              <DropdownMenuSeparator/>            
              <DropdownMenuItem className="text-red-500 text-sm" onClick={handleLogOut}>
                <LogOut className="text-red-500" />
                Log out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </SidebarMenuItem>
      </SidebarMenu>
      </UserProvider>
    )
}
